import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {Polygon} from "react-leaflet";
import "leaflet-polylineoffset";
import {withNamespaces} from "react-i18next";

function MapRestrictPolygons(props) {
  const {restrictPolygons} = props;
  const polygons = useMemo(() => restrictPolygons.map(polygon => polygon.map(ring => ring.map(point => L.latLng(point.lat, point.lon)))), [restrictPolygons]);

  return polygons.map((polygon, i) => (
    <Polygon key={i} positions={polygon}/>
  ));
}

MapRestrictPolygons.propTypes = {
  restrictPolygons: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object))).isRequired
}

export default withNamespaces()(MapRestrictPolygons);
